export enum SellType {
    UNKNOWN = 0,
    PRIMARY = 1,
    PRIMARY_REASSIGNMENT = 2,
    SECONDARY = 3,
    SECONDARY_PRIMARY = 4,
    ALTERNATIVE = 5
}
